import React from 'react';

// Multi-segment progress bar: several coloured runs sharing one track, with the
// remainder left as unfilled track. The existing .progress-wrap / .progress-fill
// pair only models a single fill, which cannot show "89 of 120 done, of which 5
// failed" in one bar — hence this rather than a third .fill-* modifier.
//
// `segments` is [{ value, color, label }]. Values are in the same units as
// `total`; anything beyond `total` is clamped so a miscount cannot overflow.
export default function SplitProgressBar({ segments = [], total = 0, height = 6, label }) {
  const safeTotal = total > 0 ? total : 0;
  const pct = v => (safeTotal ? Math.max(0, Math.min(100, (v / safeTotal) * 100)) : 0);
  const done = segments.reduce((a, s) => a + (s.value || 0), 0);

  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={safeTotal}
      aria-valuenow={done}
      aria-label={label || 'Progress'}
      style={{
        height, borderRadius: 'var(--radius-pill)', background: 'var(--surface-inset)',
        overflow: 'hidden', display: 'flex',
      }}>
      {segments.map((s, i) => (
        s.value > 0 ? (
          <div key={i} title={s.label} style={{ width: pct(s.value) + '%', background: s.color, transition: 'width 0.3s ease' }} />
        ) : null
      ))}
    </div>
  );
}
